import PropTypes from 'prop-types';
import { useState } from 'react';
import AutoSizeTextArea from 'react-textarea-autosize';
import { Button, Form, TextArea } from 'semantic-ui-react';

import { getString } from '../../utils';
import { ChatOptions } from './ChatOptions';

const ChatInput = ({ onSubmit, onStartVideoCall, onAddMeeting }) => {
  const [text, setText] = useState('');

  function submit() {
    const message = text.trim();
    if (!message) return;
    onSubmit(message);
    setText('');
  }

  return (
    <Form
      className="form--chat Chat--Input"
      onKeyUp={(e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          submit();
        }
      }}
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <TextArea
        rows={1}
        as={AutoSizeTextArea}
        type="text"
        name="message"
        placeholder={getString('chat.placeholder')}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <ChatOptions onStartVideoCall={onStartVideoCall} onAddMeeting={onAddMeeting} />
      <Button type="submit" primary circular icon="send" disabled={text.trim().length === 0} />
    </Form>
  );
};

ChatInput.defaultProps = {
  onAddMeeting: undefined,
  onStartVideoCall: undefined,
};

ChatInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onStartVideoCall: PropTypes.func,
  onAddMeeting: PropTypes.func,
};

export default ChatInput;
